export default {
  'footer.text': 'Bilim ve merak ile geliştirildi!',
  'footer.copyright':
    'COPYRIGHT © {year}<examod> Examod, </examod>Tüm hakları saklıdır |<terms> Şartlar ve Koşullar</terms><privacy> | Gizlilik Politikası</privacy><about> | Hakkında</about>',
};
